import { render, staticRenderFns } from "./EuResponsibleDetails.vue?vue&type=template&id=74bdf196&"
import script from "./EuResponsibleDetails.vue?vue&type=script&lang=js&"
export * from "./EuResponsibleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74bdf196')) {
      api.createRecord('74bdf196', component.options)
    } else {
      api.reload('74bdf196', component.options)
    }
    module.hot.accept("./EuResponsibleDetails.vue?vue&type=template&id=74bdf196&", function () {
      api.rerender('74bdf196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/EuResponsibleDetails.vue"
export default component.exports